
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cbd-store/[slug]/deals",
      function () {
        return require("private-next-pages/cbd-store/[slug]/deals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cbd-store/[slug]/deals"])
      });
    }
  